//-------------------some settings for which api and firebase to use-------------------
// variables below are used to set the api and firebase to use
// building on localhost will automatically use dev firebase and dev api unless LIVE_OVERRIDE is set to true
//
// if you are building on localhost, default settings will be dev firebase and dev api
// if you are building on vercel, default settings will be live firebase and live api
//
// if you want to force dev firebase and dev api in vft, set dev_firebase_in_preview to true
// if you want to force dev api in vft, set dev_api_in_vft to true
//
// if you want to force live firebase and live api on localhost, set live_firebase_on_localhost to true
// if you want to force live api on localhost, set live_api_on_localhost to true
//
// setting both live and dev to true may cause unexpected behavior
//
//
let live_firebase_on_localhost = false
let live_api_on_localhost = false
//--------------------------------
let dev_firebase_in_vft = false
let dev_api_in_vft = false
//
let temp_force_enterprise = true
export const FORCE_ENTERPRISE_ID = `TgNi8mpKJTnZ3Lt4Dzfp`;
//
//dev firebase testing enterprise : TgNi8mpKJTnZ3Lt4Dzfp
//bifrost: tmzBnzhaHFDH9r4A7dtm
//moonshot: S58cJMgThrMRfsM8V442
//lulzbot: 3qbEzrYUProeQRceP1Cn
//saratech: 4od0M0QFEG9mtgOCcfXT
//incept: t9WXKqgdGpfQdxN54DKi
//Printerior: dz0numTo4kbf3Z556hgl
//Tangible Creative: ndG2kwDsVqep44aCIdY4
//merck: n71A5NFtYvmupPRJHG66
//daniel: HwtWH1kIvjL7mC6VmjCn
//alphabuildprototypes: LJxeLvm5NA0rh4dp421Y
export const SCHEDULE_LOCATIONS_ENABLED_ENTERPRISE_IDS = [
    'TgNi8mpKJTnZ3Lt4Dzfp', // dev firebase testing enterprise
    't9WXKqgdGpfQdxN54DKi', // incept
]
// Enterprises that had the staff scheduler before it became a Beta setting.
// An ABSENT config/public.enableSchedule resolves ON for them only; the
// setting itself (staff/Features.vue, Scheduling card) wins either way.
// See resolveScheduleEnabled in src/components/schedule/scheduleFeatureFlags.js.
export const SCHEDULE_ENABLED_ENTERPRISE_IDS = [
    'TgNi8mpKJTnZ3Lt4Dzfp', // dev firebase testing enterprise
    't9WXKqgdGpfQdxN54DKi', // incept
]
// Enterprises where the staff-facing tech support / ticketing system is enabled.
// (Developers always have the /dev dashboard regardless of this list.)
export const SUPPORT_TICKETING_ENABLED_ENTERPRISE_IDS = [
    'TgNi8mpKJTnZ3Lt4Dzfp', // dev firebase testing enterprise
    't9WXKqgdGpfQdxN54DKi', // incept
]
// Firebase Auth UIDs that should never be logged out by the staff idle timeout policy.
export const STAFF_IDLE_TIMEOUT_IMMUNE_USER_IDS = [
    'LHj70NxCQqgX9ugCF7US2uToGPw1',
    'sY1UUHK85aglJQ4zd4x4DNAmjAq1',
    '4uIB4RVfpZgOpZwyejuANJzvKEn1',
    'Y7seuVVHPhgaRMfOSil4JmNs0iQ2',
]
// Firebase Auth UIDs for developer/superuser program members.
// These users get staff access on all enterprises and access to the Dev Dashboard.
export const DEVELOPER_USER_IDS = [
    'LHj70NxCQqgX9ugCF7US2uToGPw1',
    'sY1UUHK85aglJQ4zd4x4DNAmjAq1',
    '4uIB4RVfpZgOpZwyejuANJzvKEn1',
    'Y7seuVVHPhgaRMfOSil4JmNs0iQ2',
]
// Enterprises where developer/superuser accounts always have a user profile. The Dev Dashboard
// resolves a developer's name/avatar against these first, in this order, reading the docs by id
// directly — so resolution doesn't depend on the full enterprise list having streamed in yet
// (otherwise a developer whose home enterprise loads late briefly shows their raw UID).
// Staff of OTHER enterprises won't be here; they still resolve via the loaded enterprise list.
export const DEVELOPER_HOME_ENTERPRISE_IDS = [
    't9WXKqgdGpfQdxN54DKi', // incept
    'TgNi8mpKJTnZ3Lt4Dzfp', // preview (dev firebase testing enterprise)
]
//----------------do not edit below this line----------------
let temp_use_dev_firebase = false
let temp_use_dev_api = false
if (process.env.VUE_APP_MODE === 'preview') {
    temp_use_dev_firebase = false
    temp_use_dev_api = false
}
// if building on localhost, use dev firebase and dev api
if (process.env.VUE_APP_MODE !== 'production' && process.env.VUE_APP_MODE !== 'preview') {
    temp_use_dev_firebase = true
    temp_use_dev_api = true
}
if (live_firebase_on_localhost) {
    temp_use_dev_firebase = false
}
if (live_api_on_localhost) {
    temp_use_dev_api = false
}
if (dev_firebase_in_vft) {
    temp_use_dev_firebase = true
}
if (dev_api_in_vft) {
    temp_use_dev_api = true
}
// just a check to make sure production is being used!
// more of a failsafe for the lazy or forgetful
if (process.env.VUE_APP_MODE === 'production') {
    temp_use_dev_firebase = false
    temp_use_dev_api = false
    temp_force_enterprise = false
}
export const USE_DEV_FIREBASE = temp_use_dev_firebase
export const USE_DEV_API = temp_use_dev_api
export const FORCE_ENTERPRISE = temp_force_enterprise
